import { render } from "./HeaderCard.html?vue&type=template&id=03c4228c&ts=true&external"
import script from "./HeaderCard.ts?vue&type=script&lang=ts&external"
export * from "./HeaderCard.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__